import { useState, useEffect } from "react";

interface UseLazyLoadOptions {
  targetId: string;
  rootMargin?: string;
}

export function useLazyLoad(options: UseLazyLoadOptions) {
  const { targetId, rootMargin = "200px" } = options;
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (shouldLoad) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setShouldLoad(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    const element = document.getElementById(targetId);
    if (element) {
      observer.observe(element);
    }

    return () => {
      observer.disconnect();
    };
  }, [targetId, rootMargin, shouldLoad]);

  return shouldLoad;
}

export const LAZY_LOAD_CONFIGS = {
  GALLERY: {
    targetId: "mm-gallery-section",
    rootMargin: "200px",
  },
  EMI_CALCULATOR: {
    targetId: "mm-emi-section",
    rootMargin: "300px",
  },
  COLORS_SECTION: {
    targetId: "mm-colors-section",
    rootMargin: "250px",
  },
  COMPARISON: {
    targetId: "comparison",
    rootMargin: "400px",
  },
} as const;
